export const SECTION_HEADING_CLASSES = 'text-base font-semibold text-mp-foreground';
export const SECTION_DIVIDER_CLASSES = 'border-t border-mp-border pt-6';
